import {
  pgTable,
  text,
  timestamp,
  uuid,
  boolean,
  jsonb,
  index,
  uniqueIndex,
} from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// Custom Event Types — Tenant-defined events for Zapier-level flexibility (F4)
// ---------------------------------------------------------------------------
// Tenants register custom event types that can trigger workflows.
// Example: "custom.order_received" with a payload schema requiring { orderId, amount }.
// The workflow trigger evaluator matches these against active trigger configurations.

export const customEventTypes = pgTable("custom_event_types", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  eventType: text("event_type").notNull(), // e.g., "custom.order_received"
  displayName: text("display_name").notNull(), // Human-readable for UI
  description: text("description"),
  // Optional Zod-compatible JSON schema for payload validation at fire time
  payloadSchema: jsonb("payload_schema").$type<Record<string, unknown>>(),
  isActive: boolean("is_active").notNull().default(true),
  createdBy: uuid("created_by"),
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_custom_evt_tenant").on(table.tenantId),
  uniqueIndex("uq_custom_evt_tenant_type").on(table.tenantId, table.eventType),
]);
